import type { ProductGroup } from './types';
// Import assets inside the content module so Vite still fingerprints them.
import bovineImg from '@/assets/products/bovine_producs.png';
import ovineImg from '@/assets/products/ovine_products.jpg';
import offalImg from '@/assets/products/offal_producs.png';

export const productsContent = {
    sectionTitle: 'Our Prime Selections',
    groups: [
        {
            title: 'Bovine Executive',
            items: ['Premium Beef (Prime & Choice)', 'Tender Veal', 'High-Protein Buffalo'],
            image: bovineImg,
        },
        {
            title: 'Ovine Excellence',
            items: ['Succulent Lamb', 'Rich Mutton', 'Premium Goat'],
            image: ovineImg,
        },
        {
            title: 'Offal Excellence',
            items: ['Grass Fed Beef Liver', 'Grass Fed Beef Kidney', 'Grass Fed Beef Heart'],
            image: offalImg,
        },
    ] satisfies ProductGroup[],
};
